module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-precomposed-a21a98bd5172026ebcd1858e6eb0719e.png";